import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { useSelector } from "react-redux";

import { Badge } from "@/components/General/Badge/badge.component";
import { useProductComparisonBarContext } from "@/components/Product/ProductComparisonBar/context/productComparisonBar.context";
import * as ProductDetailSelectors from "@/redux/modules/value/productDetail/productDetail.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type TriggerButtonProps = {
    className?: string;
};

export const TriggerButton = ({ className }: TriggerButtonProps) => {
    const { t } = useGranite();

    const stickyOrderButton = useSelector(
        ProductDetailSelectors.getStickyOrderButton
    );

    const { open, products, toggle } = useProductComparisonBarContext();

    return (
        <Button
            type={"button"}
            onClick={toggle}
            size="md"
            fullWidth={true}
            className={cn("tw:ring-0! tw:md:rounded-b-none!", className)}
        >
            <i
                className={cn("las", "tw:mr-2", {
                    "la-angle-down": open,
                    "la-angle-up": !open
                })}
            />
            {!stickyOrderButton ? (
                <span>{t("productComparison.compare")}</span>
            ) : (
                <>
                    <span className="tw:inline-block tw:md:hidden">
                        {t("productComparison.compare.short")}
                    </span>
                    <span className="tw:hidden tw:md:inline-block">
                        {t("productComparison.compare")}
                    </span>
                </>
            )}
            <Badge
                inverse={true}
                className={cn("tw:ml-2 tw:hidden tw:md:inline-block")}
            >
                {products?.length || 0}/6
            </Badge>
        </Button>
    );
};
